import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';

import type { EnviarEmailHtmlComAnexosRequest, EnviarEmailHtmlRequest } from './email.model';

@Injectable({ providedIn: 'root' })
export class EmailService extends BaseService {
    readonly PATH = SICOM_PATHS.sistema.email;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    enviarTeste(to: string[], context?: HttpContext): Observable<void> {
        return this.http.post<void>(`${this.PATH}/send-test`, to, { context });
    }

    enviarHtml(payload: EnviarEmailHtmlRequest, context?: HttpContext): Observable<void> {
        return this.http.post<void>(`${this.PATH}/html`, payload, { context });
    }

    enviarHtmlComAnexos(payload: EnviarEmailHtmlComAnexosRequest, context?: HttpContext): Observable<void> {
        const formData = new FormData();

        payload.to.forEach((destinatario) => formData.append('to', destinatario));
        formData.append('subject', payload.subject);
        formData.append('html', payload.html);
        payload.attachments.forEach((arquivo) => formData.append('attachments', arquivo, arquivo.name));

        return this.http.post<void>(`${this.PATH}/html/anexos`, formData, { context });
    }
}
